import React, { FC, useContext } from 'react'
import { ChatContext } from '~/service/chatConn'
import { post } from '~/utils/api'
import { Wrapper } from './Wrapper'
import { v4 as uuidv4 } from 'uuid'

type Props = {
  disabled: boolean
  inputRef: React.MutableRefObject<HTMLTextAreaElement | undefined>
  aiLang: string
}

const completionType = 'sentenceCompletion'

const SentenceCompletion: FC<Props> = ({ disabled, inputRef, aiLang }) => {
  const { activeChat, aiCompletionStart } = useContext(ChatContext)

  const loading = activeChat.aiCompletion?.type === completionType

  return (
    <Wrapper
      disabled={loading || disabled}
      tabIndex={0}
      tip={intl.formatMessage({
        id: 'chat / input / sentence completion',
      })}
      onClick={async () => {
        const requestId = uuidv4()

        aiCompletionStart(activeChat.id, requestId, completionType)

        const value = inputRef.current?.value as string

        post<string>(`chat/aiSentenceCompletion/${activeChat.id}`, {
          answer: value,
          customUserData: activeChat.customUserData,
          requestId,
          aiLang,
        })
      }}
    >
      <span
        className={
          loading ? 'fa fa-spin fa-spinner-third' : 'far fa-lasso-sparkles'
        }
      />
    </Wrapper>
  )
}

export default SentenceCompletion
